import { ICONS } from 'consts/consts';
import React, { FC } from 'react';

/**
 * The union of every className string defined in the ICONS const. Using this as
 * the `icon` prop type limits the component to icons we've explicitly approved.
 */
export type IconValue = (typeof ICONS)[keyof typeof ICONS];

interface Props {
  icon: IconValue;
  className?: string;
}

/**
 * Renders an `<i>` element for one of the approved ICONS values, optionally with
 * extra classes. Prefer this over a raw `<i className="fe fe-..." />` so icon
 * usage stays constrained to the ICONS const.
 */
const Icon: FC<Props> = ({ icon, className }) => (
  <i className={className ? `${icon} ${className}` : icon} />
);

export default React.memo(Icon);
